import { render, staticRenderFns } from "./InstructorWarningModal.vue?vue&type=template&id=348fb53a&"
import script from "./InstructorWarningModal.vue?vue&type=script&lang=js&"
export * from "./InstructorWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Alert: require('/opt/buildhome/repo/components/global/Alert.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
